module.exports = __webpack_public_path__ + "img/SELO-REGULAR.b1c97264.png";